// import { useDispatch } from "react-redux";
// import { Row, Col, Input } from "antd";
// import _ from "lodash";

// import { ReactComponent as PlusIcon } from "@assets/images/plus-with-bg.svg";
// import { useTypedSelector } from "@hooks";
// import { handleOfferModeller } from "@store/offers";
// import { getCurrencyTotal, round } from "@utils";
// import { useFetchOfferCurrencyRateQuery } from "@/services";
// import { formatNumberWithCommas } from "@/utils/formatNumberWithCommas";
// import { currenciesConverter, calculatePropose } from "@utils";


// const OfferSummary = () => {
//   const dispatch = useDispatch();

//   const {
//     offerModeller: {
//       offer_benefits,
//       offer_lti,
//       offer_sti,
//       offer_fixed_cash,
//       offer_sign_on_bonus,
//     },
//     currencyRate,
//     currencyName,
//     offer,
//     offer_annual,
//     currentCandidateCurrency
//   } = useTypedSelector(state => state.offers);
//   const { company } = useTypedSelector(state => state.auth?.user!);
//   const { id: company_id } = company!;
//   const {
//     data: counrtyList,
//     error,
//     isLoading,
//     isFetching,
//     isSuccess,
//     isError,
//     refetch,
//   } = useFetchOfferCurrencyRateQuery(
//     {
//       code: offer?.offer_candidate_detail?.currency?.id,
//       company_id,
//       offer_id: offer?.id,
//     },
//     {
//       refetchOnMountOrArgChange: true,
//       skip: !offer?.offer_candidate_detail?.currency?.id,
//     }
//   );
//   const readOnly = offer && offer?.status !== "DRAFTED" ? true : false;
//   const currencyCode = currencyName?.split("(")[1]?.replace(")", "") || "";

//   // khurram add
//   // Stock-aware proposed LTI total (mirrors LongTermIncentives / OfferBenefits logic)
//   const selectedStock = Number((offer_lti as any)?.selected_stock_value) || 1;

//   const proposedLtiStockAware = (() => {
//     let total = Number(offer_lti?.proposed_total_lti) || 0;
//     (offer_lti?.other_ltis || [])
//       .filter((x: any) => !x?.is_current)
//       .forEach((it: any) => {
//         const v = Number(it?.value) || 0;
//         // if unit === false → "units" entry; convert to amount = units * selectedStock
//         if (!it?.unit && v) {
//           total -= v; // remove raw units that were included
//           total += round(v * selectedStock); // add amount
//         }
//       });
//     return round(total);
//   })();

//   // Proposed-only: sum all proposed (non-current) benefits line items
//   const proposedBenefitsLineTotal =
//     Number(offer_benefits?.proposed_benefit || 0) -
//     Number(offer_lti?.proposed_total_direct_comp || 0);
//   // khurram add end

//   const { current_currency_total, proposed_currency_total } = getCurrencyTotal(
//     offer_benefits,
//     currencyRate,
//     []
//   );

//   const labelColSpan = currencyCode ? 10 : 12;
//   const currencyColSpan = currencyCode ? 7 : 12;

//   const proposedStiTotal =
//     (offer_fixed_cash?.proposed_total || 0) +
//     (offer_sti?.proposed_total_bonus || 0);
//   const currentStiTotal =
//     (offer_fixed_cash?.current_total || 0) +
//     (offer_sti?.current_bonus_target || 0);

//   let percentageStiDifference = 0;

//   if (proposedStiTotal > 0 && currentStiTotal > 0) {
//     percentageStiDifference = (proposedStiTotal / currentStiTotal - 1) * 100;
//   }

//   const finalStiPercentage =
//     percentageStiDifference > 0 ? percentageStiDifference.toFixed(0) : 0;

//   // before khurram
//   // const proposedLtiTotal =
//   //   (proposedStiTotal || 0) + (offer_lti?.proposed_total_lti || 0);
//   const proposedLtiTotal = (proposedStiTotal || 0) + proposedLtiStockAware;

//   const currentLtiTotal =
//     (currentStiTotal || 0) + (offer_lti?.current_total_lti || 0);

//   let percentageLtiDifference = 0;

//   if (proposedLtiTotal > 0 && currentLtiTotal > 0) {
//     percentageLtiDifference = (proposedLtiTotal / currentLtiTotal - 1) * 100;
//   }

//   const finalLtiPercentage =
//     percentageLtiDifference > 0 ? percentageLtiDifference.toFixed(0) : 0;

//   // before khurram
//   // const proposedBenefitsTotal =
//   //   (proposedLtiTotal || 0) + (offer_benefits?.proposed_total_bonus || 0);
//   // Cumulative up through benefits = LTI (stock-aware) + proposed benefits lines
//   const proposedBenefitsTotal =
//     (proposedLtiTotal || 0) + proposedBenefitsLineTotal;

//   const currentBenefintsTotal =
//     (currentLtiTotal || 0) + (offer_benefits?.current_total_bonus || 0);

//   let percentageBenefitDifference = 0;

//   if (proposedBenefitsTotal > 0 && currentBenefintsTotal > 0) {
//     percentageBenefitDifference =
//       (proposedBenefitsTotal / currentBenefintsTotal - 1) * 100;
//   }

//   const finalBenefitPercentage =
//     percentageBenefitDifference > 0
//       ? percentageBenefitDifference.toFixed(0)
//       : 0;


//   let totalDirectLTIProposed = proposedTotal => {
//     var result =
//       offer_sti?.is_sale_incentive &&
//         offer_fixed_cash?.proposed_annual_base &&
//         offer_sti.proposed_base_pay_percentage
//         ? round(
//           (offer_fixed_cash.proposed_annual_base *
//             ((offer_fixed_cash.proposed_annual_base *
//               (100 - offer_sti.proposed_base_pay_percentage)) /
//               100)) /
//           ((offer_fixed_cash.proposed_annual_base *
//             offer_sti.proposed_base_pay_percentage) /
//             100) -
//           offer_sti.proposed_base_pay_percentage
//         ) +
//         ((offer_sti?.proposed_total_bonus || 0) +
//           (offer_fixed_cash?.proposed_total || 0))
//         : (offer_sti?.proposed_total_bonus || 0) +
//         (offer_fixed_cash?.proposed_total || 0);
//     return result + proposedTotal;
//   };

//   let totalDirectLTICurrent = proposedTotal => {
//     var result =
//       offer_fixed_cash?.current_total + offer_sti?.current_total_bonus;
//     return result + proposedTotal;
//   };


//   let totalBenefitProposed = (proposedBenefits: number) => {
//     const targetTotalCash =
//       offer_sti?.is_sale_incentive &&
//         offer_fixed_cash?.proposed_annual_base &&
//         offer_sti?.proposed_base_pay_percentage
//         ? round(
//           (offer_fixed_cash.proposed_annual_base *
//             ((offer_fixed_cash.proposed_annual_base *
//               (100 - offer_sti.proposed_base_pay_percentage)) /
//               100)) /
//           ((offer_fixed_cash.proposed_annual_base *
//             offer_sti.proposed_base_pay_percentage) /
//             100) -
//           offer_sti.proposed_base_pay_percentage
//         ) +
//         ((offer_sti?.proposed_total_bonus || 0) +
//           (offer_fixed_cash?.proposed_total || 0))
//         : (offer_sti?.proposed_total_bonus || 0) +
//         (offer_fixed_cash?.proposed_total || 0);

//     // add proposed benefits (from lines) + LTI (stock-aware)
//     return targetTotalCash + proposedBenefits + proposedLtiStockAware || 0;
//   };

//   let totalBenefitCurrent = proposedTotal => {
//     var result =
//       offer_fixed_cash?.current_total + offer_sti?.current_total_bonus;
//     return result + proposedTotal + offer_lti?.current_total_lti || 0;
//   };

//   // === Direct Comp (current/proposed) and % difference === Khurram added
//   const directCompCurrent = totalDirectLTICurrent(
//     offer_lti?.current_total_lti || 0
//   );
//   const directCompProposed = totalDirectLTIProposed(proposedLtiStockAware);
//   const directCompDiffPct =
//     directCompCurrent > 0
//       ? ((directCompProposed / directCompCurrent - 1) * 100).toFixed(2)
//       : "0.00";



//   const currentOne = offer_fixed_cash?.current_total
//   const ProposedOne = Math.round(offer_fixed_cash?.proposed_total)
//   const currencyDiffOne =
//     currenciesConverter(
//       counrtyList?.data?.result || 1,
//       ProposedOne
//     )
//   const differenceOne = calculatePropose(
//     currentOne,
//     currencyDiffOne
//   );


//   const currentTwo = offer_fixed_cash?.current_total +
//     offer_sti?.current_total_bonus
//   const ProposedTwo = Math.round(
//     offer_sti?.is_sale_incentive &&
//       offer_fixed_cash?.proposed_annual_base &&
//       offer_sti.proposed_base_pay_percentage
//       ? round(
//         (offer_fixed_cash.proposed_annual_base *
//           ((offer_fixed_cash.proposed_annual_base *
//             (100 -
//               offer_sti.proposed_base_pay_percentage)) /
//             100)) /
//         ((offer_fixed_cash.proposed_annual_base *
//           offer_sti.proposed_base_pay_percentage) /
//           100) -
//         offer_sti.proposed_base_pay_percentage
//       ) +
//       ((offer_sti?.proposed_total_bonus || 0) +
//         (offer_fixed_cash?.proposed_total || 0))
//       : (offer_sti?.proposed_total_bonus || 0) +
//       (offer_fixed_cash?.proposed_total || 0)
//   )
//   const currencyDiffTwo =
//     currenciesConverter(
//       counrtyList?.data?.result || 1,
//       ProposedTwo
//     )
//   const differenceTwo = calculatePropose(
//     currentTwo,
//     currencyDiffTwo
//   );


//   // step 3
//   const currentThree = totalDirectLTICurrent(offer_lti?.current_total_lti)
//   const ProposedThree = Math.round(
//     totalDirectLTIProposed(proposedLtiStockAware))
//   const currencyDiffThree =
//     currenciesConverter(
//       counrtyList?.data?.result || 1,
//       ProposedThree
//     )
//   const differenceThree = calculatePropose(
//     currentThree,
//     currencyDiffThree
//   );

//   // step 4
//   const currentFour = Number(
//     offer_benefits?.current_total_remuneration || 0
//   );

//   const ProposedFour = Number(
//     offer_benefits?.proposed_total_remuneration || 0
//   );
//   const currencyDiffFour =
//     currenciesConverter(
//       counrtyList?.data?.result || 1,
//       ProposedFour
//     )
//   const differenceFour = calculatePropose(
//     currentFour,
//     currencyDiffFour
//   );
//   // step 5
//   const currentFive = offer_sign_on_bonus?.current_total_bonus
//   const ProposedFive = offer_sign_on_bonus?.proposed_total_bonus
//   const currencyDiffFive =
//     currenciesConverter(
//       counrtyList?.data?.result || 1,
//       ProposedFive
//     )
//   const differenceFive = calculatePropose(
//     currentFive,
//     currencyDiffFive
//   );

//   return (
//     <>
//       <Row className="salary-offer bg-revampLightBlueBackground">
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row__col">
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div
//                 className={` ${offer_annual
//                   ? "salary-offer__content-row__field  salary-offer__content-row__field--total"
//                   : "salary-offer__content-row__field_extra  salary-offer__content-row__field--total"
//                   } `}
//               >
//                 <label>Total Guaranteed Cash</label>
//               </div>
//             </Col>

//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyColSpan}
//             >
//               <div
//                 className={` ${offer_annual
//                   ? "salary-offer__content-row__field  salary-offer__content-row__field--total"
//                   : "salary-offer__content-row__field_extra  salary-offer__content-row__field--total"
//                   } `}
//               >
//                 <div className="w-full">
//                   <Input
//                     className={`w-full shadow-md my-2 font-semibold text-sm outline-none border border-themeInputBorder bg-white px-3 py-3 rounded-md`}
//                     readOnly
//                     name="current_total"
//                     value={formatNumberWithCommas(
//                       offer_fixed_cash?.current_total || ""
//                     )}
//                     placeholder="Value here..."
//                     size="large"
//                     type="text"
//                   />

//                   {!offer_annual && (
//                     <p className="pl-1">
//                       Monthly:{" "}
//                       {formatNumberWithCommas(
//                         round(
//                           offer_fixed_cash?.current_total
//                             ? offer_fixed_cash?.current_total / 12
//                             : 0
//                         )
//                       )}
//                     </p>
//                   )}
//                 </div>
//               </div>
//             </Col>

//             {currencyCode ? (
//               <Col className="salary-offer__content-row__col" span={7}>
//                 <div
//                   className={` ${offer_annual
//                     ? "salary-offer__content-row__field  salary-offer__content-row__field--total"
//                     : "salary-offer__content-row__field_extra  salary-offer__content-row__field--total"
//                     } `}
//                 >
//                   <div>
//                     <Input
//                       className={`w-full shadow-md my-2 font-semibold text-sm outline-none border border-themeInputBorder bg-white px-3 py-3 rounded-md`}
//                       value={current_currency_total || ""}
//                       value={formatNumberWithCommas(
//                         Number(
//                           offer_fixed_cash?.current_total * currentCandidateCurrency!
//                         ).toFixed(2) || ""
//                       )}
//                       readOnly
//                       placeholder="Value here..."
//                       size="large"
//                       type="text"
//                     />

//                     {!offer_annual && (
//                       <p className="pl-1">
//                         Monthly:{" "}
//                         {formatNumberWithCommas(
//                           round(
//                             offer_fixed_cash?.current_total * currentCandidateCurrency!
//                               ? (offer_fixed_cash?.current_total *
//                                 currencyRate!) /
//                               12
//                               : 0
//                           )
//                         )}
//                       </p>
//                     )}
//                   </div>
//                 </div>

//               </Col>
//             ) : null}
//           </Row>
//         </Col>

//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row__col">
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div
//                 className={` ${offer_annual
//                   ? "salary-offer__content-row__field  salary-offer__content-row__field--total"
//                   : "salary-offer__content-row__field_extra  salary-offer__content-row__field--total"
//                   } `}
//               >
//                 <label>Total Guaranteed Cash</label>
//               </div>
//             </Col>

//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyColSpan}
//             >
//               <div
//                 className={` ${offer_annual
//                   ? "salary-offer__content-row__field  salary-offer__content-row__field--total"
//                   : "salary-offer__content-row__field_extra  salary-offer__content-row__field--total"
//                   } `}
//               >
//                 <div className="w-full">
//                   <Input
//                     className={`w-full shadow-md my-2 font-semibold text-sm outline-none border border-themeInputBorder bg-white px-3 py-3 rounded-md`}
//                     readOnly
//                     name="proposed_total"
//                     value={formatNumberWithCommas(
//                       Math.round(offer_fixed_cash?.proposed_total) || ""
//                     )}
//                     placeholder="Value here..."
//                     type="text"
//                     size="large"
//                   />

//                   {!offer_annual && (
//                     <p className="pl-1">
//                       Monthly:{" "}
//                       {formatNumberWithCommas(
//                         round(
//                           offer_fixed_cash?.proposed_total
//                             ? offer_fixed_cash?.proposed_total / 12
//                             : 0
//                         )
//                       )}
//                     </p>
//                   )}
//                 </div>
//               </div>
//             </Col>

//             {currencyCode ? (
//               <Col className="salary-offer__content-row__col" span={7}>
//                 <div
//                   className={` ${offer_annual
//                     ? "salary-offer__content-row__field  salary-offer__content-row__field--total"
//                     : "salary-offer__content-row__field_extra  salary-offer__content-row__field--total"
//                     } `}
//                 >
//                   <div className="w-full">
//                     <Input
//                       className={`w-full shadow-md my-2 font-semibold text-sm outline-none border border-themeInputBorder bg-white px-3 py-3 rounded-md`}
//                       // value={proposed_currency_total || ""}
//                       value={formatNumberWithCommas(
//                         Number(
//                           offer_fixed_cash?.proposed_total * currencyRate!
//                         ).toFixed(2) || ""
//                       )}
//                       readOnly
//                       type="text"
//                       placeholder="Value here..."
//                       size="large"
//                     />

//                     {!offer_annual && (
//                       <p className="pl-1">
//                         Monthly:{" "}
//                         {formatNumberWithCommas(
//                           round(
//                             offer_fixed_cash?.proposed_total * currencyRate!
//                               ? (offer_fixed_cash?.proposed_total *
//                                 currencyRate!) /
//                               12
//                               : 0
//                           )
//                         )}
//                       </p>
//                     )}
//                   </div>
//                 </div>
//               </Col>
//             ) : null}
//           </Row>
//         </Col>
//       </Row>

//       <Row className="salary-offer">
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row__col">
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total"></div>
//             </Col>

//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyCode ? 14 : currencyColSpan}
//             >
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total"></div>
//             </Col>
//           </Row>
//         </Col>

//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row__col">
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 <label>Difference</label>
//               </div>
//             </Col>
//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyCode ? 14 : currencyColSpan}
//             >
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 <div
//                   className={`w-full px-6   text-white shadow-md my-2 font-semibold text-center text-sm outline-none border border-themeInputBorder bg-revampBlue  py-2 rounded-md`}
//                 >
//                   {`${differenceOne.toFixed(2)}%`}
//                 </div>
//               </div>
//             </Col>
//           </Row>
//         </Col>
//       </Row>

//       <Row className="salary-offer bg-revampLightBlueBackground">
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row">
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB">
//                 <label>Target Total Cash</label>
//               </div>
//             </Col>
//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyColSpan}
//             >
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB">
//                 <Input
//                   readOnly
//                   value={formatNumberWithCommas(
//                     offer_fixed_cash?.current_total +
//                     offer_sti?.current_total_bonus || ""
//                   )}
//                   name="current_total_bonus"
//                   type="text"
//                   placeholder="Value here..."
//                   size="large"
//                 />
//               </div>
//             </Col>

//             {currencyCode ? (
//               <Col className="salary-offer__content-row__col" span={7}>
//                 <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB ">
//                   <Input
//                     value={formatNumberWithCommas(
//                       Number(
//                         (offer_fixed_cash?.current_total +
//                           offer_sti?.current_total_bonus) *
//                         currentCandidateCurrency!
//                       ).toFixed(2) || ""
//                     )}
//                     type="text"
//                     readOnly
//                     placeholder="Value here..."
//                     size="large"
//                   />
//                 </div>
//               </Col>
//             ) : null}
//           </Row>
//         </Col>
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row">
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB">
//                 <label>Target Total Cash</label>
//               </div>
//             </Col>

//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyColSpan}
//             >
//               <div className="salary-offer__content-row__field salary-offer__content-row__field">
//                 <Input
//                   readOnly
//                   value={formatNumberWithCommas(
//                     Math.round(
//                       offer_sti?.is_sale_incentive &&
//                         offer_fixed_cash?.proposed_annual_base &&
//                         offer_sti.proposed_base_pay_percentage
//                         ? round(
//                           (offer_fixed_cash.proposed_annual_base *
//                             ((offer_fixed_cash.proposed_annual_base *
//                               (100 -
//                                 offer_sti.proposed_base_pay_percentage)) /
//                               100)) /
//                           ((offer_fixed_cash.proposed_annual_base *
//                             offer_sti.proposed_base_pay_percentage) /
//                             100) -
//                           offer_sti.proposed_base_pay_percentage
//                         ) +
//                         ((offer_sti?.proposed_total_bonus || 0) +
//                           (offer_fixed_cash?.proposed_total || 0))
//                         : (offer_sti?.proposed_total_bonus || 0) +
//                         (offer_fixed_cash?.proposed_total || 0)
//                     )
//                   )}
//                   name="target_total_cash"
//                   placeholder="Value here..."
//                   size="large"
//                   type="text"
//                 />
//               </div>
//             </Col>

//             {currencyCode ? (
//               <Col className="salary-offer__content-row__col" span={7}>
//                 <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB ">
//                   <Input
//                     value={formatNumberWithCommas(
//                       (
//                         (offer_sti?.is_sale_incentive &&
//                           offer_fixed_cash?.proposed_annual_base &&
//                           offer_sti?.proposed_base_pay_percentage
//                           ? round(
//                             (offer_fixed_cash.proposed_annual_base *
//                               ((offer_fixed_cash.proposed_annual_base *
//                                 (100 -
//                                   offer_sti.proposed_base_pay_percentage)) /
//                                 100)) /
//                             ((offer_fixed_cash.proposed_annual_base *
//                               offer_sti.proposed_base_pay_percentage) /
//                               100) -
//                             offer_sti.proposed_base_pay_percentage
//                           ) +
//                           ((offer_sti?.proposed_total_bonus || 0) +
//                             (offer_fixed_cash?.proposed_total || 0))
//                           : (offer_sti?.proposed_total_bonus || 0) +
//                           (offer_fixed_cash?.proposed_total || 0)) *
//                         currencyRate!
//                       ).toFixed(2) || ""
//                     )}
//                     readOnly
//                     placeholder="Value here..."
//                     size="large"
//                     type="text"
//                   />
//                 </div>
//               </Col>
//             ) : null}
//           </Row>
//         </Col>
//       </Row>

//       <Row className="salary-offer">
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row">
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB"></div>
//             </Col>
//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyCode ? 14 : currencyColSpan}
//             >
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB"></div>
//             </Col>
//           </Row>
//         </Col>
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row">
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB">
//                 <label>Target Cash Difference</label>
//               </div>
//             </Col>

//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyCode ? 14 : currencyColSpan}
//             >
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB">
//                 <div
//                   className={`w-full px-6 text-white shadow-md my-2 font-semibold text-center text-sm outline-none border border-themeInputBorder bg-revampBlue py-2 rounded-md`}
//                 >
//                   {`${differenceTwo.toFixed(2)}%`}
//                 </div>
//               </div>
//             </Col>
//           </Row>
//         </Col>
//       </Row>

//       <Row className="salary-offer bg-revampLightBlueBackground">
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row">
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 <label>Total Direct Comp</label>
//               </div>
//             </Col>

//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyColSpan}
//             >
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 <Input
//                   readOnly
//                   name="total_direct_comp"
//                   placeholder="Value here..."
//                   value={formatNumberWithCommas(
//                     totalDirectLTICurrent(offer_lti?.current_total_lti)
//                   )}
//                   type="text"
//                   size="large"
//                 />
//               </div>
//             </Col>

//             {currencyCode ? (
//               <Col className="salary-offer__content-row__col" span={7}>
//                 <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                   <Input
//                     value={formatNumberWithCommas(
//                       round(
//                         totalDirectLTICurrent(offer_lti?.current_total_lti) *
//                         currentCandidateCurrency!
//                       ) || ""
//                     )}
//                     readOnly
//                     placeholder="Value here..."
//                     size="large"
//                     type="text"
//                   />
//                 </div>
//               </Col>
//             ) : null}
//           </Row>
//         </Col>

//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row">
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 <label>Total Direct Comp</label>
//               </div>
//             </Col>
//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyColSpan}
//             >
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 <Input
//                   readOnly
//                   name="total_direct_comp"
//                   placeholder="Value here..."

//                   value={formatNumberWithCommas(
//                     Math.round(
//                       totalDirectLTIProposed(proposedLtiStockAware)) || ""
//                   )}
//                   size="large"
//                   type="text"
//                 />
//               </div>
//             </Col>

//             {currencyCode ? (
//               <Col className="salary-offer__content-row__col" span={7}>
//                 <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                   <Input

//                     value={formatNumberWithCommas(
//                       round(
//                         totalDirectLTIProposed(proposedLtiStockAware) *
//                         currencyRate!
//                       ) || ""
//                     )}
//                     readOnly
//                     placeholder="Value here..."
//                     size="large"
//                     type="text"
//                   />
//                 </div>
//               </Col>
//             ) : null}
//           </Row>
//         </Col>
//       </Row>

//       <Row className="salary-offer">
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row">
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total"></div>
//             </Col>

//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyCode ? 14 : currencyColSpan}
//             >
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total"></div>
//             </Col>
//           </Row>
//         </Col>

//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row">
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 <label>Direct Comp Difference</label>
//               </div>
//             </Col>
//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyCode ? 14 : currencyColSpan}
//             >
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 <div
//                   className={`w-full px-6 text-white shadow-md my-2 font-semibold text-center text-sm outline-none border border-themeInputBorder bg-revampBlue py-2 rounded-md`}
//                 >

//                   {differenceThree?.toFixed(2)}%
//                 </div>
//               </div>
//             </Col>
//           </Row>
//         </Col>
//       </Row>

//       <Row className="salary-offer bg-revampLightBlueBackground">
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row salary-offer__content-row--last">
//             {/* Current-Cols */}
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 <label>Total Remuneration</label>
//               </div>
//             </Col>

//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyColSpan}
//             >
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 <Input
//                   readOnly
//                   value={formatNumberWithCommas(
//                     totalBenefitCurrent(
//                       offer_benefits?.current_total_bonus || 0
//                     ) || ""
//                   )}
//                   name="current_total_lti"
//                   placeholder="Value here..."
//                   size="large"
//                   type="text"
//                 />
//               </div>
//             </Col>

//             {currencyCode ? (
//               <Col className="salary-offer__content-row__col" span={7}>
//                 <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                   <Input
//                     value={formatNumberWithCommas(
//                       round(
//                         totalBenefitCurrent(
//                           offer_benefits?.current_total_bonus || 0
//                         ) * currentCandidateCurrency!
//                       ) || ""
//                     )}
//                     readOnly
//                     placeholder="Value here..."
//                     size="large"
//                     type="text"
//                   />
//                 </div>
//               </Col>
//             ) : null}
//           </Row>
//         </Col>
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row salary-offer__content-row--last">
//             {/* Current-Cols */}
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 <label>Total Remuneration</label>
//               </div>
//             </Col>

//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyColSpan}
//             >
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 <Input
//                   readOnly
//                   name="proposed_total_lti"

//                   value={formatNumberWithCommas(
//                     Math.round(Number(offer_benefits?.proposed_total_remuneration || 0)) || ""
//                   )}

//                   placeholder="Value here..."
//                   type="text"
//                   size="large"
//                 />
//               </div>
//             </Col>

//             {currencyCode ? (
//               <Col className="salary-offer__content-row__col" span={7}>
//                 <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                   <Input

//                     value={formatNumberWithCommas(
//                       round(
//                         totalBenefitProposed(proposedBenefitsLineTotal) *
//                         currencyRate!
//                       ) || ""
//                     )}
//                     readOnly
//                     placeholder="Value here..."
//                     size="large"
//                     type="text"
//                   />
//                 </div>
//               </Col>
//             ) : null}
//           </Row>
//         </Col>
//       </Row>

//       <Row className="salary-offer">
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row salary-offer__content-row--last">
//             {/* Current-Cols */}
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total"></div>
//             </Col>

//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyCode ? 14 : currencyColSpan}
//             >
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total"></div>
//             </Col>
//           </Row>
//         </Col>
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row salary-offer__content-row--last">
//             {/* Current-Cols */}
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 <label>Remuneration Difference</label>
//               </div>
//             </Col>

//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyCode ? 14 : currencyColSpan}
//             >
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 <div
//                   className={`w-full px-6   text-white shadow-md my-2 font-semibold text-center text-sm outline-none border border-themeInputBorder bg-revampBlue  py-2 rounded-md`}
//                 >

//                   {differenceFour?.toFixed(2)}%
//                 </div>
//               </div>
//             </Col>
//           </Row>
//         </Col>
//       </Row>

//       <Row className="salary-offer bg-revampLightBlueBackground">
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row salary-offer__content-row--last">
//             {/* Current-Cols */}
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 {/* <label>Total Package Payment</label> */}
//                 <label>One Time Payment</label>
//               </div>
//             </Col>

//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyColSpan}
//             >
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 <Input
//                   readOnly
//                   value={formatNumberWithCommas(
//                     offer_sign_on_bonus?.current_total_bonus || ""
//                   )}
//                   name="current_total_lti"
//                   placeholder="Value here..."
//                   size="large"
//                   type="text"
//                 />
//               </div>
//             </Col>

//             {currencyCode ? (
//               <Col className="salary-offer__content-row__col" span={7}>
//                 <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                   <Input
//                     value={formatNumberWithCommas(
//                       Number(
//                         offer_sign_on_bonus?.current_total_bonus * currentCandidateCurrency!
//                       ).toFixed(2) || ""
//                     )}
//                     readOnly
//                     placeholder="Value here..."
//                     size="large"
//                     type="text"
//                   />
//                 </div>
//               </Col>
//             ) : null}
//           </Row>
//         </Col>
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row salary-offer__content-row--last">
//             {/* Current-Cols */}
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 {/* <label>Total Package Payment</label> */}
//                 <label>One Time Payment</label>
//               </div>
//             </Col>

//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyColSpan}
//             >
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 <Input
//                   readOnly
//                   name="proposed_total_lti"
//                   value={formatNumberWithCommas(
//                     offer_sign_on_bonus?.proposed_total_bonus || ""
//                   )}
//                   placeholder="Value here..."
//                   size="large"
//                   type="text"
//                 />
//               </div>
//             </Col>

//             {currencyCode ? (
//               <Col className="salary-offer__content-row__col" span={7}>
//                 <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                   <Input
//                     value={formatNumberWithCommas(
//                       Number(
//                         offer_sign_on_bonus?.proposed_total_bonus *
//                         currencyRate!
//                       ).toFixed(2) || ""
//                     )}
//                     readOnly
//                     placeholder="Value here..."
//                     size="large"
//                     type="text"
//                   />
//                 </div>
//               </Col>
//             ) : null}
//           </Row>
//         </Col>
//       </Row>

//       <Row className="salary-offer">
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row salary-offer__content-row--last">
//             {/* Current-Cols */}
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total"></div>
//             </Col>

//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyCode ? 14 : currencyColSpan}
//             >
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total"></div>
//             </Col>
//           </Row>
//         </Col>
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row salary-offer__content-row--last">
//             {/* Current-Cols */}
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 {/* <label>Total Package Difference</label> */}
//                 <label> One Time Payment Difference</label>
//               </div>
//             </Col>

//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyCode ? 14 : currencyColSpan}
//             >
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 <div
//                   className={`w-full px-6   text-white shadow-md my-2 font-semibold text-center text-sm outline-none border border-themeInputBorder bg-revampBlue  py-2 rounded-md`}
//                 >

//                   {differenceFive.toFixed(2)}%
//                 </div>
//               </div>
//             </Col>
//           </Row>
//         </Col>
//       </Row>
//     </>
//   );
// };

// export default OfferSummary;



// v2
import { useDispatch } from "react-redux";
import { Row, Col, Input } from "antd";
import _ from "lodash";

import { ReactComponent as PlusIcon } from "@assets/images/plus-with-bg.svg";
import { useTypedSelector } from "@hooks";
import { handleOfferModeller } from "@store/offers";
import { calculatePercentageAmount, getCurrencyTotal, round } from "@utils";
import { useFetchOfferCurrencyRateQuery } from "@/services";
import { formatNumberWithCommas } from "@/utils/formatNumberWithCommas";
import { currenciesConverter, calculatePropose } from "@utils";


const OfferSummary = () => {
  const dispatch = useDispatch();

  const {
    offerModeller: {
      offer_benefits,
      offer_lti,
      offer_sti,
      offer_fixed_cash,
      offer_sign_on_bonus,
    },
    currencyRate,
    currencyName,
    offer,
    offer_annual,
    currentCandidateCurrency
  } = useTypedSelector(state => state.offers);
  const { company } = useTypedSelector(state => state.auth?.user!);
  const { id: company_id } = company!;
  const {
    data: counrtyList,
    error,
    isLoading,
    isFetching,
    isSuccess,
    isError,
    refetch,
  } = useFetchOfferCurrencyRateQuery(
    {
      code: offer?.offer_candidate_detail?.currency?.id,
      company_id,
      offer_id: offer?.id,
    },
    {
      refetchOnMountOrArgChange: true,
      skip: !offer?.offer_candidate_detail?.currency?.id,
    }
  );
  const readOnly = offer && offer?.status !== "DRAFTED" ? true : false;
  const currencyCode = currencyName?.split("(")[1]?.replace(")", "") || "";

  // khurram add
  // Stock-aware proposed LTI total (mirrors LongTermIncentives / OfferBenefits logic)
  const selectedStock = Number((offer_lti as any)?.selected_stock_value) || 1;

  const proposedLtiStockAware = (() => {
    let total = Number(offer_lti?.proposed_total_lti) || 0;
    (offer_lti?.other_ltis || [])
      .filter((x: any) => !x?.is_current)
      .forEach((it: any) => {
        const v = Number(it?.value) || 0;
        // if unit === false → "units" entry; convert to amount = units * selectedStock
        if (!it?.unit && v) {
          total -= v; // remove raw units that were included
          total += round(v * selectedStock); // add amount
        }
      });
    return round(total);
  })();

  const calculateBenefitValue = (benefit: any): number => {
    if (benefit?.show_custom_detail) {
      return 0;
    }

    const rawCte =
      benefit?.benefit_value_or_cte ??
      benefit?.value ??
      benefit?.percentage ??
      0;

    const cte = Number(rawCte) || 0;
    const calculationBasis = benefit?.calculation_basis;
    const annualBaseSalary =
      Number(offer_fixed_cash?.proposed_annual_base) || 0;
    const guaranteedCash = Number(offer_fixed_cash?.proposed_total) || 0;

    switch (calculationBasis) {
      case "percent_basic":
        return calculatePercentageAmount(annualBaseSalary, cte);

      case "percent_guaranteed":
      case "percent_actual":
        return calculatePercentageAmount(guaranteedCash, cte);

      case "multiple_of_weekly_basic":
        return round((annualBaseSalary / 52) * cte);

      case "flat":
      default:
        return cte;
    }
  };

  const getBenefitTotalContribution = (benefit: any): number => {
    const calculatedBenefitValue = calculateBenefitValue(benefit);
    const rawBenefitLimit = benefit?.benefit_limit;

    const hasValidBenefitLimit =
      rawBenefitLimit !== null &&
      rawBenefitLimit !== undefined &&
      rawBenefitLimit !== "" &&
      Number.isFinite(Number(rawBenefitLimit)) &&
      Number(rawBenefitLimit) > 0;

    return hasValidBenefitLimit
      ? Math.min(calculatedBenefitValue, Number(rawBenefitLimit))
      : calculatedBenefitValue;
  };

  // Proposed Total Benefits excludes benefits explicitly excluded from the offer.
  const proposedBenefitsLineTotal = (offer_benefits?.bonuses || [])
    .filter(
      (benefit: any) =>
        !benefit?.is_current && !benefit?.exclude_from_offer
    )
    .reduce(
      (total: number, benefit: any) =>
        total + getBenefitTotalContribution(benefit),
      0
    );

  // Total Remuneration includes all proposed benefits, matching OfferBenefits.
  const proposedBenefitsRemunerationTotal = (offer_benefits?.bonuses || [])
    .filter((benefit: any) => !benefit?.is_current)
    .reduce(
      (total: number, benefit: any) =>
        total + getBenefitTotalContribution(benefit),
      0
    );
  // khurram add end

  const { current_currency_total, proposed_currency_total } = getCurrencyTotal(
    offer_benefits,
    currencyRate,
    []
  );

  const labelColSpan = currencyCode ? 10 : 12;
  const currencyColSpan = currencyCode ? 7 : 12;

  const proposedStiTotal =
    (offer_fixed_cash?.proposed_total || 0) +
    (offer_sti?.proposed_total_bonus || 0);
  const currentStiTotal =
    (offer_fixed_cash?.current_total || 0) +
    (offer_sti?.current_bonus_target || 0);

  let percentageStiDifference = 0;

  if (proposedStiTotal > 0 && currentStiTotal > 0) {
    percentageStiDifference = (proposedStiTotal / currentStiTotal - 1) * 100;
  }

  const finalStiPercentage =
    percentageStiDifference > 0 ? percentageStiDifference.toFixed(0) : 0;

  // before khurram
  // const proposedLtiTotal =
  //   (proposedStiTotal || 0) + (offer_lti?.proposed_total_lti || 0);
  const proposedLtiTotal = (proposedStiTotal || 0) + proposedLtiStockAware;

  const currentLtiTotal =
    (currentStiTotal || 0) + (offer_lti?.current_total_lti || 0);

  let percentageLtiDifference = 0;

  if (proposedLtiTotal > 0 && currentLtiTotal > 0) {
    percentageLtiDifference = (proposedLtiTotal / currentLtiTotal - 1) * 100;
  }

  const finalLtiPercentage =
    percentageLtiDifference > 0 ? percentageLtiDifference.toFixed(0) : 0;

  // before khurram
  // const proposedBenefitsTotal =
  //   (proposedLtiTotal || 0) + (offer_benefits?.proposed_total_bonus || 0);
  // Cumulative up through benefits = LTI (stock-aware) + proposed benefits lines
  const proposedBenefitsTotal =
    (proposedLtiTotal || 0) + proposedBenefitsLineTotal;

  const currentBenefintsTotal =
    (currentLtiTotal || 0) + (offer_benefits?.current_total_bonus || 0);

  let percentageBenefitDifference = 0;

  if (proposedBenefitsTotal > 0 && currentBenefintsTotal > 0) {
    percentageBenefitDifference =
      (proposedBenefitsTotal / currentBenefintsTotal - 1) * 100;
  }

  const finalBenefitPercentage =
    percentageBenefitDifference > 0
      ? percentageBenefitDifference.toFixed(0)
      : 0;


  let totalDirectLTIProposed = proposedTotal => {
    var result =
      offer_sti?.is_sale_incentive &&
        offer_fixed_cash?.proposed_annual_base &&
        offer_sti.proposed_base_pay_percentage
        ? round(
          (offer_fixed_cash.proposed_annual_base *
            ((offer_fixed_cash.proposed_annual_base *
              (100 - offer_sti.proposed_base_pay_percentage)) /
              100)) /
          ((offer_fixed_cash.proposed_annual_base *
            offer_sti.proposed_base_pay_percentage) /
            100) -
          offer_sti.proposed_base_pay_percentage
        ) +
        ((offer_sti?.proposed_total_bonus || 0) +
          (offer_fixed_cash?.proposed_total || 0))
        : (offer_sti?.proposed_total_bonus || 0) +
        (offer_fixed_cash?.proposed_total || 0);
    return result + proposedTotal;
  };

  let totalDirectLTICurrent = proposedTotal => {
    var result =
      offer_fixed_cash?.current_total + offer_sti?.current_total_bonus;
    return result + proposedTotal;
  };


  let totalBenefitProposed = (proposedBenefits: number) => {
    const targetTotalCash =
      offer_sti?.is_sale_incentive &&
        offer_fixed_cash?.proposed_annual_base &&
        offer_sti?.proposed_base_pay_percentage
        ? round(
          (offer_fixed_cash.proposed_annual_base *
            ((offer_fixed_cash.proposed_annual_base *
              (100 - offer_sti.proposed_base_pay_percentage)) /
              100)) /
          ((offer_fixed_cash.proposed_annual_base *
            offer_sti.proposed_base_pay_percentage) /
            100) -
          offer_sti.proposed_base_pay_percentage
        ) +
        ((offer_sti?.proposed_total_bonus || 0) +
          (offer_fixed_cash?.proposed_total || 0))
        : (offer_sti?.proposed_total_bonus || 0) +
        (offer_fixed_cash?.proposed_total || 0);

    // add proposed benefits (from lines) + LTI (stock-aware)
    return targetTotalCash + proposedBenefits + proposedLtiStockAware || 0;
  };

  let totalBenefitCurrent = proposedTotal => {
    var result =
      offer_fixed_cash?.current_total + offer_sti?.current_total_bonus;
    return result + proposedTotal + offer_lti?.current_total_lti || 0;
  };

  const proposedTotalRemuneration = totalBenefitProposed(
    proposedBenefitsRemunerationTotal
  );

  // === Direct Comp (current/proposed) and % difference === Khurram added
  const directCompCurrent = totalDirectLTICurrent(
    offer_lti?.current_total_lti || 0
  );
  const directCompProposed = totalDirectLTIProposed(proposedLtiStockAware);
  const directCompDiffPct =
    directCompCurrent > 0
      ? ((directCompProposed / directCompCurrent - 1) * 100).toFixed(2)
      : "0.00";



  const currentOne = offer_fixed_cash?.current_total
  const ProposedOne = Math.round(offer_fixed_cash?.proposed_total)
  const currencyDiffOne =
    currenciesConverter(
      counrtyList?.data?.result || 1,
      ProposedOne
    )
  const differenceOne = calculatePropose(
    currentOne,
    currencyDiffOne
  );


  const currentTwo = offer_fixed_cash?.current_total +
    offer_sti?.current_total_bonus
  const ProposedTwo = Math.round(
    offer_sti?.is_sale_incentive &&
      offer_fixed_cash?.proposed_annual_base &&
      offer_sti.proposed_base_pay_percentage
      ? round(
        (offer_fixed_cash.proposed_annual_base *
          ((offer_fixed_cash.proposed_annual_base *
            (100 -
              offer_sti.proposed_base_pay_percentage)) /
            100)) /
        ((offer_fixed_cash.proposed_annual_base *
          offer_sti.proposed_base_pay_percentage) /
          100) -
        offer_sti.proposed_base_pay_percentage
      ) +
      ((offer_sti?.proposed_total_bonus || 0) +
        (offer_fixed_cash?.proposed_total || 0))
      : (offer_sti?.proposed_total_bonus || 0) +
      (offer_fixed_cash?.proposed_total || 0)
  )
  const currencyDiffTwo =
    currenciesConverter(
      counrtyList?.data?.result || 1,
      ProposedTwo
    )
  const differenceTwo = calculatePropose(
    currentTwo,
    currencyDiffTwo
  );


  // step 3
  const currentThree = totalDirectLTICurrent(offer_lti?.current_total_lti)
  const ProposedThree = Math.round(
    totalDirectLTIProposed(proposedLtiStockAware))
  const currencyDiffThree =
    currenciesConverter(
      counrtyList?.data?.result || 1,
      ProposedThree
    )
  const differenceThree = calculatePropose(
    currentThree,
    currencyDiffThree
  );

  // step 4
  const currentFour = Number(
    offer_benefits?.current_total_remuneration || 0
  );

  const ProposedFour = Math.round(proposedTotalRemuneration);
  const currencyDiffFour =
    currenciesConverter(
      counrtyList?.data?.result || 1,
      ProposedFour
    )
  const differenceFour = calculatePropose(
    currentFour,
    currencyDiffFour
  );
  // step 5
  const currentFive = offer_sign_on_bonus?.current_total_bonus
  const ProposedFive = offer_sign_on_bonus?.proposed_total_bonus
  const currencyDiffFive =
    currenciesConverter(
      counrtyList?.data?.result || 1,
      ProposedFive
    )
  const differenceFive = calculatePropose(
    currentFive,
    currencyDiffFive
  );

  return (
    <>
      <Row className="salary-offer bg-revampLightBlueBackground">
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row__col">
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div
                className={` ${offer_annual
                  ? "salary-offer__content-row__field  salary-offer__content-row__field--total"
                  : "salary-offer__content-row__field_extra  salary-offer__content-row__field--total"
                  } `}
              >
                <label>Total Guaranteed Cash</label>
              </div>
            </Col>

            <Col
              className="salary-offer__content-row__col"
              span={currencyColSpan}
            >
              <div
                className={` ${offer_annual
                  ? "salary-offer__content-row__field  salary-offer__content-row__field--total"
                  : "salary-offer__content-row__field_extra  salary-offer__content-row__field--total"
                  } `}
              >
                <div className="w-full">
                  <Input
                    className={`w-full shadow-md my-2 font-semibold text-sm outline-none border border-themeInputBorder bg-white px-3 py-3 rounded-md`}
                    readOnly
                    name="current_total"
                    value={formatNumberWithCommas(
                      offer_fixed_cash?.current_total || ""
                    )}
                    placeholder="Value here..."
                    size="large"
                    type="text"
                  />

                  {!offer_annual && (
                    <p className="pl-1">
                      Monthly:{" "}
                      {formatNumberWithCommas(
                        round(
                          offer_fixed_cash?.current_total
                            ? offer_fixed_cash?.current_total / 12
                            : 0
                        )
                      )}
                    </p>
                  )}
                </div>
              </div>
            </Col>

            {currencyCode ? (
              <Col className="salary-offer__content-row__col" span={7}>
                <div
                  className={` ${offer_annual
                    ? "salary-offer__content-row__field  salary-offer__content-row__field--total"
                    : "salary-offer__content-row__field_extra  salary-offer__content-row__field--total"
                    } `}
                >
                  <div>
                    <Input
                      className={`w-full shadow-md my-2 font-semibold text-sm outline-none border border-themeInputBorder bg-white px-3 py-3 rounded-md`}
                      value={current_currency_total || ""}
                      value={formatNumberWithCommas(
                        Number(
                          offer_fixed_cash?.current_total * currentCandidateCurrency!
                        ).toFixed(2) || ""
                      )}
                      readOnly
                      placeholder="Value here..."
                      size="large"
                      type="text"
                    />

                    {!offer_annual && (
                      <p className="pl-1">
                        Monthly:{" "}
                        {formatNumberWithCommas(
                          round(
                            offer_fixed_cash?.current_total * currentCandidateCurrency!
                              ? (offer_fixed_cash?.current_total *
                                currencyRate!) /
                              12
                              : 0
                          )
                        )}
                      </p>
                    )}
                  </div>
                </div>

              </Col>
            ) : null}
          </Row>
        </Col>

        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row__col">
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div
                className={` ${offer_annual
                  ? "salary-offer__content-row__field  salary-offer__content-row__field--total"
                  : "salary-offer__content-row__field_extra  salary-offer__content-row__field--total"
                  } `}
              >
                <label>Total Guaranteed Cash</label>
              </div>
            </Col>

            <Col
              className="salary-offer__content-row__col"
              span={currencyColSpan}
            >
              <div
                className={` ${offer_annual
                  ? "salary-offer__content-row__field  salary-offer__content-row__field--total"
                  : "salary-offer__content-row__field_extra  salary-offer__content-row__field--total"
                  } `}
              >
                <div className="w-full">
                  <Input
                    className={`w-full shadow-md my-2 font-semibold text-sm outline-none border border-themeInputBorder bg-white px-3 py-3 rounded-md`}
                    readOnly
                    name="proposed_total"
                    value={formatNumberWithCommas(
                      Math.round(offer_fixed_cash?.proposed_total) || ""
                    )}
                    placeholder="Value here..."
                    type="text"
                    size="large"
                  />

                  {!offer_annual && (
                    <p className="pl-1">
                      Monthly:{" "}
                      {formatNumberWithCommas(
                        round(
                          offer_fixed_cash?.proposed_total
                            ? offer_fixed_cash?.proposed_total / 12
                            : 0
                        )
                      )}
                    </p>
                  )}
                </div>
              </div>
            </Col>

            {currencyCode ? (
              <Col className="salary-offer__content-row__col" span={7}>
                <div
                  className={` ${offer_annual
                    ? "salary-offer__content-row__field  salary-offer__content-row__field--total"
                    : "salary-offer__content-row__field_extra  salary-offer__content-row__field--total"
                    } `}
                >
                  <div className="w-full">
                    <Input
                      className={`w-full shadow-md my-2 font-semibold text-sm outline-none border border-themeInputBorder bg-white px-3 py-3 rounded-md`}
                      // value={proposed_currency_total || ""}
                      value={formatNumberWithCommas(
                        Number(
                          offer_fixed_cash?.proposed_total * currencyRate!
                        ).toFixed(2) || ""
                      )}
                      readOnly
                      type="text"
                      placeholder="Value here..."
                      size="large"
                    />

                    {!offer_annual && (
                      <p className="pl-1">
                        Monthly:{" "}
                        {formatNumberWithCommas(
                          round(
                            offer_fixed_cash?.proposed_total * currencyRate!
                              ? (offer_fixed_cash?.proposed_total *
                                currencyRate!) /
                              12
                              : 0
                          )
                        )}
                      </p>
                    )}
                  </div>
                </div>
              </Col>
            ) : null}
          </Row>
        </Col>
      </Row>

      <Row className="salary-offer">
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row__col">
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total"></div>
            </Col>

            <Col
              className="salary-offer__content-row__col"
              span={currencyCode ? 14 : currencyColSpan}
            >
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total"></div>
            </Col>
          </Row>
        </Col>

        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row__col">
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                <label>Difference</label>
              </div>
            </Col>
            <Col
              className="salary-offer__content-row__col"
              span={currencyCode ? 14 : currencyColSpan}
            >
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                <div
                  className={`w-full px-6   text-white shadow-md my-2 font-semibold text-center text-sm outline-none border border-themeInputBorder bg-revampBlue  py-2 rounded-md`}
                >
                  {`${differenceOne.toFixed(2)}%`}
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className="salary-offer bg-revampLightBlueBackground">
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row">
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB">
                <label>Target Total Cash</label>
              </div>
            </Col>
            <Col
              className="salary-offer__content-row__col"
              span={currencyColSpan}
            >
              <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB">
                <Input
                  readOnly
                  value={formatNumberWithCommas(
                    offer_fixed_cash?.current_total +
                    offer_sti?.current_total_bonus || ""
                  )}
                  name="current_total_bonus"
                  type="text"
                  placeholder="Value here..."
                  size="large"
                />
              </div>
            </Col>

            {currencyCode ? (
              <Col className="salary-offer__content-row__col" span={7}>
                <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB ">
                  <Input
                    value={formatNumberWithCommas(
                      Number(
                        (offer_fixed_cash?.current_total +
                          offer_sti?.current_total_bonus) *
                        currentCandidateCurrency!
                      ).toFixed(2) || ""
                    )}
                    type="text"
                    readOnly
                    placeholder="Value here..."
                    size="large"
                  />
                </div>
              </Col>
            ) : null}
          </Row>
        </Col>
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row">
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB">
                <label>Target Total Cash</label>
              </div>
            </Col>

            <Col
              className="salary-offer__content-row__col"
              span={currencyColSpan}
            >
              <div className="salary-offer__content-row__field salary-offer__content-row__field">
                <Input
                  readOnly
                  value={formatNumberWithCommas(
                    Math.round(
                      offer_sti?.is_sale_incentive &&
                        offer_fixed_cash?.proposed_annual_base &&
                        offer_sti.proposed_base_pay_percentage
                        ? round(
                          (offer_fixed_cash.proposed_annual_base *
                            ((offer_fixed_cash.proposed_annual_base *
                              (100 -
                                offer_sti.proposed_base_pay_percentage)) /
                              100)) /
                          ((offer_fixed_cash.proposed_annual_base *
                            offer_sti.proposed_base_pay_percentage) /
                            100) -
                          offer_sti.proposed_base_pay_percentage
                        ) +
                        ((offer_sti?.proposed_total_bonus || 0) +
                          (offer_fixed_cash?.proposed_total || 0))
                        : (offer_sti?.proposed_total_bonus || 0) +
                        (offer_fixed_cash?.proposed_total || 0)
                    )
                  )}
                  name="target_total_cash"
                  placeholder="Value here..."
                  size="large"
                  type="text"
                />
              </div>
            </Col>

            {currencyCode ? (
              <Col className="salary-offer__content-row__col" span={7}>
                <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB ">
                  <Input
                    value={formatNumberWithCommas(
                      (
                        (offer_sti?.is_sale_incentive &&
                          offer_fixed_cash?.proposed_annual_base &&
                          offer_sti?.proposed_base_pay_percentage
                          ? round(
                            (offer_fixed_cash.proposed_annual_base *
                              ((offer_fixed_cash.proposed_annual_base *
                                (100 -
                                  offer_sti.proposed_base_pay_percentage)) /
                                100)) /
                            ((offer_fixed_cash.proposed_annual_base *
                              offer_sti.proposed_base_pay_percentage) /
                              100) -
                            offer_sti.proposed_base_pay_percentage
                          ) +
                          ((offer_sti?.proposed_total_bonus || 0) +
                            (offer_fixed_cash?.proposed_total || 0))
                          : (offer_sti?.proposed_total_bonus || 0) +
                          (offer_fixed_cash?.proposed_total || 0)) *
                        currencyRate!
                      ).toFixed(2) || ""
                    )}
                    readOnly
                    placeholder="Value here..."
                    size="large"
                    type="text"
                  />
                </div>
              </Col>
            ) : null}
          </Row>
        </Col>
      </Row>

      <Row className="salary-offer">
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row">
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB"></div>
            </Col>
            <Col
              className="salary-offer__content-row__col"
              span={currencyCode ? 14 : currencyColSpan}
            >
              <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB"></div>
            </Col>
          </Row>
        </Col>
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row">
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB">
                <label>Target Cash Difference</label>
              </div>
            </Col>

            <Col
              className="salary-offer__content-row__col"
              span={currencyCode ? 14 : currencyColSpan}
            >
              <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB">
                <div
                  className={`w-full px-6 text-white shadow-md my-2 font-semibold text-center text-sm outline-none border border-themeInputBorder bg-revampBlue py-2 rounded-md`}
                >
                  {`${differenceTwo.toFixed(2)}%`}
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className="salary-offer bg-revampLightBlueBackground">
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row">
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                <label>Total Direct Comp</label>
              </div>
            </Col>

            <Col
              className="salary-offer__content-row__col"
              span={currencyColSpan}
            >
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                <Input
                  readOnly
                  name="total_direct_comp"
                  placeholder="Value here..."
                  value={formatNumberWithCommas(
                    totalDirectLTICurrent(offer_lti?.current_total_lti)
                  )}
                  type="text"
                  size="large"
                />
              </div>
            </Col>

            {currencyCode ? (
              <Col className="salary-offer__content-row__col" span={7}>
                <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                  <Input
                    value={formatNumberWithCommas(
                      round(
                        totalDirectLTICurrent(offer_lti?.current_total_lti) *
                        currentCandidateCurrency!
                      ) || ""
                    )}
                    readOnly
                    placeholder="Value here..."
                    size="large"
                    type="text"
                  />
                </div>
              </Col>
            ) : null}
          </Row>
        </Col>

        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row">
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                <label>Total Direct Comp</label>
              </div>
            </Col>
            <Col
              className="salary-offer__content-row__col"
              span={currencyColSpan}
            >
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                <Input
                  readOnly
                  name="total_direct_comp"
                  placeholder="Value here..."

                  value={formatNumberWithCommas(
                    Math.round(
                      totalDirectLTIProposed(proposedLtiStockAware)) || ""
                  )}
                  size="large"
                  type="text"
                />
              </div>
            </Col>

            {currencyCode ? (
              <Col className="salary-offer__content-row__col" span={7}>
                <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                  <Input

                    value={formatNumberWithCommas(
                      round(
                        totalDirectLTIProposed(proposedLtiStockAware) *
                        currencyRate!
                      ) || ""
                    )}
                    readOnly
                    placeholder="Value here..."
                    size="large"
                    type="text"
                  />
                </div>
              </Col>
            ) : null}
          </Row>
        </Col>
      </Row>

      <Row className="salary-offer">
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row">
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total"></div>
            </Col>

            <Col
              className="salary-offer__content-row__col"
              span={currencyCode ? 14 : currencyColSpan}
            >
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total"></div>
            </Col>
          </Row>
        </Col>

        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row">
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                <label>Direct Comp Difference</label>
              </div>
            </Col>
            <Col
              className="salary-offer__content-row__col"
              span={currencyCode ? 14 : currencyColSpan}
            >
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                <div
                  className={`w-full px-6 text-white shadow-md my-2 font-semibold text-center text-sm outline-none border border-themeInputBorder bg-revampBlue py-2 rounded-md`}
                >

                  {differenceThree?.toFixed(2)}%
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className="salary-offer bg-revampLightBlueBackground">
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row salary-offer__content-row--last">
            {/* Current-Cols */}
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                <label>Total Remuneration</label>
              </div>
            </Col>

            <Col
              className="salary-offer__content-row__col"
              span={currencyColSpan}
            >
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                <Input
                  readOnly
                  value={formatNumberWithCommas(
                    totalBenefitCurrent(
                      offer_benefits?.current_total_bonus || 0
                    ) || ""
                  )}
                  name="current_total_lti"
                  placeholder="Value here..."
                  size="large"
                  type="text"
                />
              </div>
            </Col>

            {currencyCode ? (
              <Col className="salary-offer__content-row__col" span={7}>
                <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                  <Input
                    value={formatNumberWithCommas(
                      round(
                        totalBenefitCurrent(
                          offer_benefits?.current_total_bonus || 0
                        ) * currentCandidateCurrency!
                      ) || ""
                    )}
                    readOnly
                    placeholder="Value here..."
                    size="large"
                    type="text"
                  />
                </div>
              </Col>
            ) : null}
          </Row>
        </Col>
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row salary-offer__content-row--last">
            {/* Current-Cols */}
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                <label>Total Remuneration</label>
              </div>
            </Col>

            <Col
              className="salary-offer__content-row__col"
              span={currencyColSpan}
            >
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                <Input
                  readOnly
                  name="proposed_total_lti"

                  value={formatNumberWithCommas(
                    Math.round(proposedTotalRemuneration) || ""
                  )}

                  placeholder="Value here..."
                  type="text"
                  size="large"
                />
              </div>
            </Col>

            {currencyCode ? (
              <Col className="salary-offer__content-row__col" span={7}>
                <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                  <Input

                    value={formatNumberWithCommas(
                      round(
                        proposedTotalRemuneration *
                        currencyRate!
                      ) || ""
                    )}
                    readOnly
                    placeholder="Value here..."
                    size="large"
                    type="text"
                  />
                </div>
              </Col>
            ) : null}
          </Row>
        </Col>
      </Row>

      <Row className="salary-offer">
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row salary-offer__content-row--last">
            {/* Current-Cols */}
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total"></div>
            </Col>

            <Col
              className="salary-offer__content-row__col"
              span={currencyCode ? 14 : currencyColSpan}
            >
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total"></div>
            </Col>
          </Row>
        </Col>
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row salary-offer__content-row--last">
            {/* Current-Cols */}
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                <label>Remuneration Difference</label>
              </div>
            </Col>

            <Col
              className="salary-offer__content-row__col"
              span={currencyCode ? 14 : currencyColSpan}
            >
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                <div
                  className={`w-full px-6   text-white shadow-md my-2 font-semibold text-center text-sm outline-none border border-themeInputBorder bg-revampBlue  py-2 rounded-md`}
                >

                  {differenceFour?.toFixed(2)}%
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className="salary-offer bg-revampLightBlueBackground">
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row salary-offer__content-row--last">
            {/* Current-Cols */}
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                {/* <label>Total Package Payment</label> */}
                <label>One Time Payment</label>
              </div>
            </Col>

            <Col
              className="salary-offer__content-row__col"
              span={currencyColSpan}
            >
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                <Input
                  readOnly
                  value={formatNumberWithCommas(
                    offer_sign_on_bonus?.current_total_bonus || ""
                  )}
                  name="current_total_lti"
                  placeholder="Value here..."
                  size="large"
                  type="text"
                />
              </div>
            </Col>

            {currencyCode ? (
              <Col className="salary-offer__content-row__col" span={7}>
                <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                  <Input
                    value={formatNumberWithCommas(
                      Number(
                        offer_sign_on_bonus?.current_total_bonus * currentCandidateCurrency!
                      ).toFixed(2) || ""
                    )}
                    readOnly
                    placeholder="Value here..."
                    size="large"
                    type="text"
                  />
                </div>
              </Col>
            ) : null}
          </Row>
        </Col>
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row salary-offer__content-row--last">
            {/* Current-Cols */}
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                {/* <label>Total Package Payment</label> */}
                <label>One Time Payment</label>
              </div>
            </Col>

            <Col
              className="salary-offer__content-row__col"
              span={currencyColSpan}
            >
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                <Input
                  readOnly
                  name="proposed_total_lti"
                  value={formatNumberWithCommas(
                    offer_sign_on_bonus?.proposed_total_bonus || ""
                  )}
                  placeholder="Value here..."
                  size="large"
                  type="text"
                />
              </div>
            </Col>

            {currencyCode ? (
              <Col className="salary-offer__content-row__col" span={7}>
                <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                  <Input
                    value={formatNumberWithCommas(
                      Number(
                        offer_sign_on_bonus?.proposed_total_bonus *
                        currencyRate!
                      ).toFixed(2) || ""
                    )}
                    readOnly
                    placeholder="Value here..."
                    size="large"
                    type="text"
                  />
                </div>
              </Col>
            ) : null}
          </Row>
        </Col>
      </Row>

      <Row className="salary-offer">
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row salary-offer__content-row--last">
            {/* Current-Cols */}
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total"></div>
            </Col>

            <Col
              className="salary-offer__content-row__col"
              span={currencyCode ? 14 : currencyColSpan}
            >
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total"></div>
            </Col>
          </Row>
        </Col>
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row salary-offer__content-row--last">
            {/* Current-Cols */}
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                {/* <label>Total Package Difference</label> */}
                <label> One Time Payment Difference</label>
              </div>
            </Col>

            <Col
              className="salary-offer__content-row__col"
              span={currencyCode ? 14 : currencyColSpan}
            >
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                <div
                  className={`w-full px-6   text-white shadow-md my-2 font-semibold text-center text-sm outline-none border border-themeInputBorder bg-revampBlue  py-2 rounded-md`}
                >

                  {differenceFive.toFixed(2)}%
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default OfferSummary;
